import React from 'react';

const CODE_CONFIG = {
  S: { label: 'SS', color: 'bg-[#c4333e] text-white', title: 'Swinging Strike' },
  C: { label: 'CK', color: 'bg-[#c4333e] text-white', title: 'Called Strike' },
  F: { label: 'FO', color: 'bg-[rgba(196,51,62,0.6)] text-white', title: 'Foul' },
  B: { label: 'BL', color: 'bg-[#386646] text-[#d8ceb3]', title: 'Ball' },
  X: { label: 'IP', color: 'bg-[#d8ceb3] text-[#1e3a29]', title: 'In Play' },
  D: { label: 'IP', color: 'bg-[#d8ceb3] text-[#1e3a29]', title: 'In Play' },
  E: { label: 'IP', color: 'bg-[#d8ceb3] text-[#1e3a29]', title: 'In Play' },
  H: { label: 'HR', color: 'bg-[#c4333e] text-white', title: 'Home Run' },
  T: { label: 'FT', color: 'bg-[rgba(196,51,62,0.5)] text-white', title: 'Foul Tip' },
  I: { label: 'IB', color: 'bg-[#386646] text-[#a9c9b1]', title: 'Intentional Ball' },
  P: { label: 'PO', color: 'bg-[#386646] text-[#a9c9b1]', title: 'Pitchout' },
  K: { label: 'SS', color: 'bg-[#c4333e] text-white', title: 'Strike (Bunt)' },
};

const PitchCodeBadge = ({ code, size = 'sm' }) => {
  const cfg = CODE_CONFIG[code] || { label: code || '--', color: 'bg-[#658d71] text-white', title: code };
  const sizeClass = size === 'xs' ? 'text-[7px] px-1 py-0.5' : 'text-[8px] px-1.5 py-0.5';
  return (
    <span className={`font-black uppercase tracking-widest ${cfg.color} ${sizeClass} shrink-0`} title={cfg.title}>
      {cfg.label}
    </span>
  );
};

export default PitchCodeBadge;